/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Mgr_LiftInputs */



/**
* | output |
* | --- |
* | "Lift" |
*
* @param {Sanction_Mgr_LiftInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_mgr_lift = /** @type {((inputs?: Sanction_Mgr_LiftInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Mgr_LiftInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lever")
	if (locale === "es") return /** @type {LocalizedString} */ ("Levantar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Remover")
	if (locale === "it") return /** @type {LocalizedString} */ ("Revoca")
	return /** @type {LocalizedString} */ ("Lift")
});